import { render, staticRenderFns } from "./Cristal.vue?vue&type=template&id=1263bc26&"
import script from "./Cristal.vue?vue&type=script&lang=js&"
export * from "./Cristal.vue?vue&type=script&lang=js&"
import style0 from "./Cristal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports